import { useEffect } from 'react';

import { VIEWS } from '../constants';
import { effJiraKey, jiraKeySharedWithOtherPhase } from '../utils/jira';
import { cardPhase } from '../utils/phases';

const isMaintenance = (ph) =>
  ph.facturation === 'maintenance_corrective' || ph.facturation === 'maintenance_evolutive';

// Phases dont il faut le suivi par label : vue détail = toutes les phases du client ouvert ; liste
// Projets = la phase affichée sur la carte de chaque client (ouverte seulement) ; Timeline = les maintenances qui partagent leur projet
// Jira avec une autre phase (leur temps est retiré du « consommé Jira » de cette autre phase).
function phasesToLoad(view, clients, selectedClient) {
  if (view === VIEWS.TIMELINE)
    return clients.flatMap((c) =>
      (c.phases || [])
        .filter((ph) => isMaintenance(ph) && jiraKeySharedWithOtherPhase(clients, ph, c))
        .map((ph) => [c, ph]),
    );
  if (selectedClient) {
    const c = clients.find((x) => x.id === selectedClient);
    return c ? (c.phases || []).map((ph) => [c, ph]) : [];
  }
  return clients.map((c) => [c, cardPhase(c)]).filter(([, ph]) => ph);
}

// Auto-charge le suivi par label Jira (correctif/évolutif) des phases de maintenance, sans
// attendre un clic sur "Actualiser".
export function useMaintenanceLabelHoursAutoload({
  appDataLoaded,
  loadLabelHours,
  maintenanceLabelHours,
  profile,
  selectedClient,
  session,
  appState,
}) {
  useEffect(() => {
    const view = appState.view;
    if (!session || !profile || (view !== VIEWS.PROJECTS && view !== VIEWS.TIMELINE)) return;
    const selected = view === VIEWS.PROJECTS ? selectedClient : null;
    for (const [c, ph] of phasesToLoad(view, appState.clients || [], selected)) {
      if (isMaintenance(ph) && effJiraKey(ph, c) && !maintenanceLabelHours[ph.id])
        loadLabelHours(ph, c);
    }
  }, [selectedClient, appState.view, session, profile, appDataLoaded]);
}
